<template>
  <div class="Warp">
    <van-grid :column-num="3" :border="false">
      <van-grid-item text="姓名" />
      <van-grid-item text="是否企业管理员" />
      <van-grid-item text="申请企业员工状态" />
    </van-grid>
    <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="uploader"
      >
        <van-cell
          v-for="item in consumerList"
          :key="item.cid"
          @click="toDetail(item)"
        >
          <van-grid :column-num="3" :border="false">
            <van-grid-item :text="item.name" />
            <!-- <van-grid-item class="compant_name" text="说的话就发了客户接受的了看见对方离开手机都发了看见了可上单就放开了" /> -->
            <van-grid-item>
              <div class="grid-item">
                <span style="margin-right: 10px">
                  {{ item.is_company_manager ? "是" : "否" }}
                </span>
                <van-switch
                  v-model="item.checked"
                  @click.stop="changeChecked(item)"
                  size="20px"
                />
              </div>
            </van-grid-item>
            <van-grid-item
              :text="item.apply_company_status == 1 ? '已开通' : '审核中'"
            />
          </van-grid>
        </van-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      company_id: "",
      page: 1,
      limit: 10,
      consumerList: [],
      loading: false,
      refreshLoading: false,
      finished: false,
      checked: true,
    };
  },
  mounted() {
    this.getConsumerList();
  },
  methods: {
    changeChecked(item) {
      item.checked = !item.checked;
      item.is_company_manager = item.checked ? 1 : 0;
      var reqData = {
        cid: item.cid,
        status: item.is_company_manager,
      };
      this.$http
        .post("/wechat/api.Salesman/companyManager", reqData, {
          emulateJSON: true,
        })
        .then((res1) => {
          var res = res1.body;
          //  this.$toast.success(res.msg)
        })
        .catch((err) => {
          this.$toast.fail("操作失败");
          item.checked = !item.checked;
          item.is_company_manager = item.checked ? 1 : 0;
        });
    },
    getConsumerList() {
      console.log(this.$route.query);
      var reqData = {
        company_id: this.$route.query.id,
        page: this.page,
        limit: this.limit,
      };
      this.$http
        .get("/wechat/api.salesman/companyConsumer", { params: reqData })
        .then((res1) => {
          var res = res1.body;
          console.log(res);
          res.data.rows.map((v) => {
            v.checked = v.is_company_manager == 1 ? true : false;
            this.consumerList.push(v);
          });
          this.loading = false;
          this.refreshLoading = false;
          if (this.consumerList.length >= res.data.count) {
            this.finished = true;
          }
        });
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.consumerList = [];
      this.finished = false;
      this.getConsumerList();
    },
    uploader() {
      this.page++;
      this.getConsumerList();
    },
    toDetail(item) {
      this.$router.push({ path: "/consumerDetail", query: item });
    },
  },
};
</script>
<style lang="less" scoped>
.grid-item {
  display: flex;
  align-items: center;
  color: #646566;
  font-size: 0.32rem;
  // line-height: 1.5;
  word-break: break-all;
}
</style>